/**
 * Room validation for the admin app.
 *
 * Mirrors the room slice of `yoga_school_admin_dashboard/src/validation/index.ts`
 * so the admin-driven room management page enforces the same client-side rules
 * as the school dashboard.
 */

export const ROOM_LIMITS = {
  name: { max: 100 },
  capacity: { min: 1, max: 20 },
  notes: { max: 500 },
} as const

export type RoomValidationErrors = Record<string, string>

export interface RoomFormInput {
  name: string
  type: string
  capacity: number
  notes?: string
}

export function validateRoom(data: RoomFormInput): RoomValidationErrors {
  const err: RoomValidationErrors = {}

  const n = (data.name ?? '').trim()
  if (!n) err.name = 'Room name is required'
  else if (n.length > ROOM_LIMITS.name.max)
    err.name = `Room name cannot exceed ${ROOM_LIMITS.name.max} characters`

  if (!(data.type ?? '').trim()) err.type = 'Room type is required'

  if (data.capacity == null || isNaN(data.capacity))
    err.capacity = 'Room capacity is required'
  else if (data.capacity < ROOM_LIMITS.capacity.min)
    err.capacity = `Room capacity must be at least ${ROOM_LIMITS.capacity.min}`
  else if (data.capacity > ROOM_LIMITS.capacity.max)
    err.capacity = `Room capacity cannot exceed ${ROOM_LIMITS.capacity.max}`

  if (data.notes?.trim() && data.notes.trim().length > ROOM_LIMITS.notes.max)
    err.notes = `Notes cannot exceed ${ROOM_LIMITS.notes.max} characters`

  return err
}
